export const tenantA4Letter2nd = {
  pageSize: 'A4',
  pageOrientation: 'portrait',
  pageMargins: [ 40, 100, 40, 110 ],
  info: {
    title: '',
    author: 'Demo GmbH, Berlin',
    subject: '',
    revison: 'Rev 01/2026',
  },
  background: function(currentPage: number, pageCount: number){
    var address = '';
    var revisionNo = 'Rev 01/2026';
    if (currentPage === 1) { address = 'Demo GmbH · Musterstraße 1 · 10115 Berlin'; }
    return [
      {
        svg:
          '<svg xmlns="http://www.w3.org/2000/svg" width="595" height="842" viewBox="0 0 595 842">' +
          '<defs>' +
            '<style>' +
              '.d-bar{fill:#0057a8;}' +
              '.d-accent{fill:#f0a500;}' +
              '.d-line{stroke:#0057a8;stroke-width:0.5px;fill:none;}' +
              '.d-footer{fill:#777777;font-family:Helvetica,Arial,sans-serif;font-size:7px;}' +
              '.d-addr{fill:#333333;font-family:Helvetica,Arial,sans-serif;font-size:7px;}' +
              '.d-logo-text{fill:#0057a8;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:bold;}' +
              '.d-logo-sub{fill:#f0a500;font-family:Helvetica,Arial,sans-serif;font-size:8px;letter-spacing:2px;}' +
            '</style>' +
          '</defs>' +
          '<rect class="d-bar" x="0" y="0" width="595" height="68"/>' +
          '<rect class="d-accent" x="555" y="0" width="40" height="68"/>' +
          '<text class="d-logo-text" transform="translate(40 42)" fill="#ffffff">Demo GmbH</text>' +
          '<text class="d-logo-sub" transform="translate(40 58)" fill="#f0a500">MUSTERFIRMA</text>' +
          '<line class="d-line" x1="0" y1="420.95" x2="14" y2="420.95"/>' +
          '<line class="d-line" x1="1.69" y1="297.64" x2="15.86" y2="297.64"/>' +
          '<line class="d-line" x1="1.69" y1="595.78" x2="15.86" y2="595.78"/>' +
          '<text class="d-footer" transform="translate(71 790)">Demo GmbH · Musterstraße 1 · 10115 Berlin</text>' +
          '<text class="d-footer" transform="translate(71 800)">Tel: +49 (0)30 123456-0 · E-Mail: info@demo-gmbh.de · Internet: www.demo-gmbh.de</text>' +
          '<text class="d-footer" transform="translate(71 810)">Amtsgericht Berlin-Charlottenburg HRB 123456 · Geschäftsführer: Max Mustermann · USt-IdNr.: DE123456789</text>' +
          '<text class="d-footer" transform="translate(71 820)">Bankverbindung: Musterbank AG · DE00 1234 5678 9012 3456 00 · BIC: MUSTDE00XXX</text>' +
          '<text class="d-footer" transform="translate(505 820)">' + revisionNo + '</text>' +
          '</svg>'
      }
    ]
  },
  footer: function(currentPage: number, pageCount: number) {
    return [
      { text: 'Seite ' + currentPage.toString() + ' von ' + pageCount, style: 'small', margin: [70, 10] },
    ]
  },
  content: [
    { columns: [
        {
          width: 230,
          text: 'Musterkunde AG\nBeispielweg 42\n12345 Musterstadt',
          style: 'address', margin: [30, 75]
        },
        {
          width: 70,
          text: ' '
        },
        {
          width: 200,
          text: 'Berlin, 18.05.2026\n\nIhr Ansprechpartner:\nMax Mustermann\nmax.mustermann@demo-gmbh.de', style: 'address', margin: [30, 75]
        }
      ],
      columnGap: 10
    },
    { text: 'Angebot Nr. 2026-0001 – Folgeseite', style: 'header', margin: [30, -30] },
    { text: '(Die Angebotsnummer im Schriftverkehr unbedingt angeben!)', style: 'small', margin: [30, 30] },
    { text: 'Sehr geehrte Damen und Herren,', style: 'normal', margin: [30, -15] },
    {
      layout: 'lightHorizontalLines',
      table: {
        headerRows: 1,
        widths: [ 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto' ],
        body: [
          [
            { text: 'Pos.' }, { text: 'Anzahl' }, { text: 'Bezeichnung' }, { text: 'Zeichnung' }, { text: 'Material' }, { text: 'Kurzbeschreibung' }, { text: 'Preis/St.' }
          ],
          [ '004', '20', 'Normteil DIN 933 M8x30', '–', 'A2', 'Sechskantschraube verzinkt', { text: '0,85 EUR', alignment: 'right' } ],
          [ '005', '1',  'Montageleistung pauschal', '–', '–', 'Einbau und Inbetriebnahme vor Ort', { text: '800,00 EUR', alignment: 'right' } ]
        ]
      },
      style: 'table',
      margin: [30, 30]
    },
    {
      layout: 'noBorders',
      table: {
        headerRows: 0,
        widths: [ 'auto', 'auto' ],
        body: [
          [ 'Preis gesamt (Seite 2):', '817,00 EUR netto, zzgl. gesetzlicher MWSt.' ],
          [ 'Bemerkungen:', 'Positionen 4 und 5 ergänzen das Hauptangebot auf Seite 1.' ],
        ]
      },
      style: 'normal',
      margin: [30, 10]
    },
    { text: 'Wir hoffen, dass dieses Angebot Ihren Vorstellungen entspricht und freuen uns auf die Zusammenarbeit.', style: 'normal', margin: [30, 0] },
    { text: 'Mit freundlichen Grüßen aus Berlin\nDemo GmbH', style: 'normal', margin: [30, 20] },
    {
      id: 'subline',
      text: 'Dieses Schreiben wurde maschinell erstellt und ist ohne Unterschrift gültig.', style: 'small', margin: [30, 20],
      pageBreak: 'after'
    },
    {
      text: 'Demo GmbH\nAllgemeine Geschäftsbedingungen (AGB)',
      style: 'header',
      margin: [30, 10]
    },
    {
      ol: [
        'Diese Bedingungen gelten für alle Lieferungen und Leistungen der Demo GmbH. Abweichende Bedingungen des Auftraggebers werden nur mit ausdrücklicher schriftlicher Zustimmung der Demo GmbH Vertragsbestandteil.',
        'Preise verstehen sich ab Werk zuzüglich gesetzlicher Mehrwertsteuer. Zahlungen sind innerhalb von 30 Tagen nach Rechnungsdatum ohne Abzug fällig.',
        'Lieferzeiten sind unverbindlich, sofern nicht ausdrücklich als verbindlich bestätigt. Bei höherer Gewalt verlängern sich vereinbarte Fristen angemessen.',
        'Mangelhafte Lieferungen werden nach Wahl der Demo GmbH nachgebessert oder ersetzt. Weitergehende Ansprüche sind ausgeschlossen, soweit gesetzlich zulässig.',
        'Es gilt das Recht der Bundesrepublik Deutschland. Erfüllungsort und Gerichtsstand ist Berlin.',
      ],
      style: 'agb',
      margin: [30, 10, 60, 10]
    },
    {
      text: 'Berlin, Mai 2026',
      style: 'agb',
      margin: [30, 0]
    }
  ],

  styles: {
    address: {
      fontSize: 10,
      bold: false
    },
    header: {
      fontSize: 11,
      bold: true
    },
    table: {
      fontSize: 8,
      bold: false
    },
    normal: {
      fontSize: 10,
      bold: false
    },
    agb: {
      fontSize: 8,
      color: '#ccc',
      bold: false
    },
    fett: {
      fontSize: 10,
      bold: true
    },
    small: {
      fontSize: 7,
      bold: false
    },
    positionText: {
      margin: [10, 0]
    }
  }
};
